import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-fulfillment-common/fulfillment-tote-group";
import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const duplicateToteGroup = {
  name: "duplicateToteGroup" as const,
  input: z.object({
    toteGroupId: zExt.objectId(),
    newGroupName: z.string(),
    toteNames: z.array(z.string()),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    toteGroup: RedoFulfillmentToteGroupSchema,
    totes: z.array(RedoFulfillmentToteSchema),
  }),
};
